<template>
  <!-- 直播记录 -->
  <div class="index-container">
    <bannerImg bannerText="直播记录" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="r-title">我的直播</div>
        <div class="type-tab-box">
          <div
            class="type-list"
            :class="typeActive === index ? 'type-active' : ''"
            v-for="(item, index) in typeList"
            :key="'type' + index"
            @click="typeSelect(item, index)"
          >{{ item.label }}</div>
        </div>
        <div class="play-box">
          <div
            class="play-list"
            @click="goDetail(item)"
            v-for="(item,index) in recordList"
            :key="'record' + index"
          >
            <div class="r-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.cover + ')' }">
              <div
                class="list-status"
                :class="item.play_status == 1?'no-status':(item.play_status == 3?'over-status':'')"
              >
                <i
                  class="iconfont-icon"
                  :class="item.play_status == 1?'icon-weikaishi':(item.play_status === 3?'icon-jingshi1':'icon-ziyuanldpi')"
                ></i>
                {{item.play_status == 1?'未开始':(item.play_status == 2?'直播中':"已结束")}}
              </div>
              <div class="r-title">{{item.title}}</div>
            </div>
            <div class="info-box">
              <div class="info-module">
                <div
                  class="r-date"
                  :class="item.play_status === 2?'ing-date':(item.play_status === 3?'over-date':'')"
                >直播时间：{{item.start_time}}</div>
                <div>
                  <i class="iconfont-icon icon-kefu"></i>联系客服
                </div>
              </div>
              <div class="info-module">
                <div
                  class="info-img"
                  :style="{ backgroundImage: 'url( ' + imgUrl + item.teacher_avatar + ')' }"
                ></div>
                <div class="info-name">{{item.teacher_name}}</div>
                <div class="info-price">
                  ¥
                  <span>{{item.price}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :page-size="page_size"
          :total="listTotal"
        ></el-pagination>
      </div>
    </personalSidebar>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'playRecord',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      typeList: [
        {
          value: '',
          label: '全部直播'
        },
        {
          value: 1,
          label: '未开始'
        },
        {
          value: 2,
          label: '直播中'
        },
        {
          value: 3,
          label: '已完成'
        }
      ],
      typeActive: 0,
      recordList: [],
      page_index: 1,
      page_size: 6,
      play_status: '',
      listTotal: 0,
      imgUrl: imgUrl
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        play_status: this.play_status
      };
      api.getPlayRecordList(params).then(res => {
        console.log(res);
        if (res.result.data) {
          this.recordList = res.result.data;
          this.listTotal = res.result.total;
        }
      });
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    typeSelect(item, index) {
      this.typeActive = index;
      this.play_status = item.value;
      this.getList();
    },
    goDetail(item) {
      //   this.$router.push({
      //     path: '/recordDetail',
      //     query: { order_sn: item.order_sn }
      //   });
      this.$router.push({
        path: '/playDetail',
        query: { uuid: item.uuid }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 32PX 30PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  border-radius: 10PX;
}
.r-title {
  padding-bottom: 38PX;
  font-size: 20PX;
}
.type-tab-box {
  display: flex;
  border-bottom: 1PX solid #ececec;
  .type-list {
    padding-bottom: 12PX;
    margin-right: 50PX;
    font-size: 18PX;
    border-bottom: 2PX solid transparent;
    cursor: pointer;
    &:hover {
      color: #f1a373;
      border-bottom: 3PX solid #f1a373;
    }
  }
  .type-active {
    color: #f1a373;
    border-bottom: 3PX solid #f1a373;
  }
}
.play-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 44PX;
}
.play-list {
  width: 46%;
  margin-bottom: 32PX;
  cursor: pointer;
  &:hover {
    box-shadow: 0PX 3PX 15PX 1PX rgba(200, 200, 200, 0.35);
  }
  .list-status {
    width: 80PX;
    height: 30PX;
    font-size: 12PX;
    color: #77e323;
    text-align: center;
    line-height: 30PX;
    background: rgba($color: #151515, $alpha: 0.4);
    border-radius: 0PX 0PX 19PX 0PX;
  }
  .no-status {
    color: #ffffff;
  }
  .over-status {
    color: #f91818;
  }
  .icon-weikaishi {
    color: #ffffff;
  }
  .icon-jingshi1 {
    color: #f91818;
  }
  .icon-ziyuanldpi {
    color: #77e323;
  }
  .r-img {
    position: relative;
    width: 100%;
    height: 234PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #331f76;
  }
  .r-title {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 12PX;
    font-size: 16PX;
    color: #ffffff;
    line-height: 52PX;
    background-color: rgba($color: #000000, $alpha: 0.35);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .info-box {
    border: 1PX solid #ededed;
    border-top: none;
  }
  .info-module {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14PX 10PX;
    color: #666666;
  }
  .icon-kefu {
    padding-right: 6PX;
  }
  .r-date {
    padding: 0 12PX;
    font-size: 12PX;
    color: #eca021;
    line-height: 26PX;
    background-color: #fff4ec;
    border-radius: 12PX;
  }
  .ing-date {
    color: #32a508;
    background-color: #ebfbeb;
  }
  .over-date {
    color: #b1b0ae;
    background-color: #eaeaea;
  }
  .info-img {
    width: 40PX;
    height: 40PX;
    margin-right: 14PX;
    border-radius: 50%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .info-name {
    flex: 1;
    color: #333333;
  }
  .info-price {
    color: #f10000;
    span {
      font-size: 22PX;
      font-weight: 500;
    }
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-bottom: 80PX;
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/playRecord.vue